import {API_ROOT} from "../config";
import fetch from 'cross-fetch';


export function fetchBusinessById(id) {
  return fetch(API_ROOT + `/businesses/${id.toString()}/`).then(response => {
    if (response.status === 200) {
      return response.json()
    }
    return null;
  });
}

export function fetchJobs() {
  return fetch(API_ROOT + '/jobs/').then(response => {
    if (response.status === 200) {
      return response.json()
    }
    return null;
  });
}



// WEBPACK FOOTER //
// ./src/services/index.js